import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Icon from 'app/components/ui/Icon';
import styles from './Button.scss';

export const Button = ({
    onClick,
    icon,
    children,
    disabled,
    variant,
    iconPosition,
    padless,
    sizeless,
    extraClassName,
    ...rest
}) => (
    <button
        className={cn({
            [styles.button]: true,
            [styles.padless]: padless,
            [styles.sizeless]: sizeless,
            [styles.primary]: variant === 'primary',
            [styles.secondary]: variant === 'secondary',
            [extraClassName]: Boolean(extraClassName),
        })}
        onClick={onClick}
        disabled={disabled}
        {...rest}
    >
        {(icon && iconPosition === 'left') && <Icon name={icon} />}
        {children}
        {(icon && iconPosition === 'right') && <Icon name={icon} />}
    </button>
);

Button.propTypes = {
    onClick: PropTypes.func.isRequired,
    icon: PropTypes.string,
    extraClassName: PropTypes.string,
    children: PropTypes.node,
    disabled: PropTypes.bool,
    variant: PropTypes.oneOf(['clear', 'primary', 'secondary']),
    iconPosition: PropTypes.oneOf(['left', 'right']),
    padless: PropTypes.bool,
    sizeless: PropTypes.bool,
};

Button.defaultProps = {
    children: null,
    icon: null,
    disabled: false,
    variant: 'clear',
    iconPosition: 'left',
    padless: false,
    sizeless: false,
    extraClassName: null,
};
